var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 142,
    viewBox: "0 0 148 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1686551085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    d: "M12.8984 106.812H138.998",
    stroke: "#D4DCD5",
    strokeWidth: 0.365454,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_2",
    d: "M12.8984 89.1426H138.998",
    stroke: "#D4DCD5",
    strokeWidth: 0.365454,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_3",
    d: "M12.8984 71.4727H138.998",
    stroke: "#D4DCD5",
    strokeWidth: 0.365454,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_4",
    d: "M12.8984 53.8047H138.998",
    stroke: "#D4DCD5",
    strokeWidth: 0.365454,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_5",
    d: "M12.8984 36.1348H138.998",
    stroke: "#D4DCD5",
    strokeWidth: 0.365454,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_6",
    d: "M12.8984 18.4453H138.998",
    stroke: "#D4DCD5",
    strokeWidth: 0.365454,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_7",
    d: "M117.984 0.666016V124.482",
    stroke: "#D4DCD5",
    strokeWidth: 0.365454,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_8",
    d: "M96.9531 0.666016V124.482",
    stroke: "#D4DCD5",
    strokeWidth: 0.365454,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_9",
    d: "M75.9375 0.666016V124.482",
    stroke: "#D4DCD5",
    strokeWidth: 0.365454,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_10",
    d: "M54.9219 0.666016V124.482",
    stroke: "#D4DCD5",
    strokeWidth: 0.365454,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_11",
    d: "M33.9141 0.666016V124.482",
    stroke: "#D4DCD5",
    strokeWidth: 0.365454,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_12",
    d: "M116.789 17.8711L93.5818 41.0787L79.369 26.8776L50.374 55.8726L37.579 43.0892L13 67.6682V75.222L37.579 50.643L50.374 63.4381L79.369 34.4314L93.5818 48.6442L120.578 21.648L116.789 17.8711Z",
    fill: "#62C676"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_13",
    d: "M124.401 14L109.805 17.9164L120.496 28.5963L124.401 14Z",
    fill: "#62C676"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1686551084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_14",
    d: "M19.875 125.015C17.7922 124.489 14.9421 124.16 11.7851 124.16C8.64992 124.16 5.7998 124.489 3.71702 125.015H0.296875V127.142C0.296875 128.764 5.42709 130.102 11.7851 130.102C18.143 130.102 23.2952 128.764 23.2952 127.142V125.015H19.875Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_15",
    d: "M23.2952 125.016C23.2952 126.661 18.143 127.998 11.7851 127.998C5.42709 127.998 0.296875 126.661 0.296875 125.016C0.296875 123.372 5.42709 122.057 11.7851 122.057C18.143 122.057 23.2952 123.372 23.2952 125.016Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_16",
    d: "M21.2344 125.016C21.2344 126.375 17.0031 127.449 11.7852 127.449C6.56727 127.449 2.33594 126.375 2.33594 125.016C2.33594 123.678 6.56727 122.582 11.7852 122.582C17.0031 122.582 21.2344 123.678 21.2344 125.016Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_17",
    d: "M19.9866 125.017C19.9866 126.179 16.3253 127.143 11.787 127.143C7.27068 127.143 3.60938 126.179 3.60938 125.017C3.60938 123.855 7.27068 122.912 11.787 122.912C16.3253 122.912 19.9866 123.855 19.9866 125.017Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    d: "M14.414 124.335H12.5066C12.8355 124.401 13.0986 124.489 13.1643 124.642H14.414V124.774H13.1643C13.0547 125.081 12.112 125.278 10.6212 125.3C11.542 125.541 12.5285 125.848 13.4932 126.155H12.3751C11.4762 125.87 10.6212 125.607 9.54688 125.3V125.124H10.1827C11.4323 125.124 12.112 124.993 12.1778 124.774H9.54688V124.642H12.1558C11.9804 124.467 11.3666 124.379 10.3581 124.379H9.54688V124.182H14.414V124.335Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_18",
    d: "M19.875 121.839C17.7922 121.313 14.9421 120.984 11.7851 120.984C8.64992 120.984 5.7998 121.313 3.71702 121.839H0.296875V123.966C0.296875 125.61 5.42709 126.926 11.7851 126.926C18.143 126.926 23.2952 125.61 23.2952 123.966V121.839H19.875Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_19",
    d: "M23.2952 121.841C23.2952 123.485 18.143 124.822 11.7851 124.822C5.42709 124.822 0.296875 123.485 0.296875 121.841C0.296875 120.196 5.42709 118.881 11.7851 118.881C18.143 118.881 23.2952 120.196 23.2952 121.841Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_20",
    d: "M21.2344 121.84C21.2344 123.199 17.0031 124.295 11.7852 124.295C6.56727 124.295 2.33594 123.199 2.33594 121.84C2.33594 120.502 6.56727 119.406 11.7852 119.406C17.0031 119.406 21.2344 120.502 21.2344 121.84Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_21",
    d: "M19.9866 121.841C19.9866 123.025 16.3253 123.968 11.787 123.968C7.27068 123.968 3.60938 123.025 3.60938 121.841C3.60938 120.679 7.27068 119.736 11.787 119.736C16.3253 119.736 19.9866 120.679 19.9866 121.841Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_2",
    d: "M14.414 121.161H12.5066C12.8355 121.227 13.0986 121.337 13.1643 121.468H14.414V121.622H13.1643C13.0547 121.929 12.112 122.126 10.6212 122.126C11.542 122.367 12.5285 122.674 13.4932 122.981H12.3751C11.4762 122.696 10.6212 122.433 9.54688 122.148V121.951H10.1827C11.4323 121.951 12.112 121.819 12.1778 121.622H9.54688V121.468H12.1558C11.9804 121.293 11.3666 121.205 10.3581 121.205H9.54688V121.008H14.414V121.161Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_22",
    d: "M19.875 118.679C17.7922 118.131 14.9421 117.824 11.7851 117.824C8.64992 117.824 5.7998 118.131 3.71702 118.679H0.296875V120.784C0.296875 122.428 5.42709 123.766 11.7851 123.766C18.143 123.766 23.2952 122.428 23.2952 120.784V118.679H19.875Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_23",
    d: "M23.2952 118.679C23.2952 120.301 18.143 121.639 11.7851 121.639C5.42709 121.639 0.296875 120.301 0.296875 118.679C0.296875 117.035 5.42709 115.697 11.7851 115.697C18.143 115.697 23.2952 117.035 23.2952 118.679Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_24",
    d: "M21.2344 118.678C21.2344 120.016 17.0031 121.112 11.7852 121.112C6.56727 121.112 2.33594 120.016 2.33594 118.678C2.33594 117.319 6.56727 116.223 11.7852 116.223C17.0031 116.223 21.2344 117.319 21.2344 118.678Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_25",
    d: "M19.9866 118.679C19.9866 119.841 16.3253 120.784 11.787 120.784C7.27068 120.784 3.60938 119.841 3.60938 118.679C3.60938 117.495 7.27068 116.553 11.787 116.553C16.3253 116.553 19.9866 117.495 19.9866 118.679Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_3",
    d: "M14.414 117.978H12.5066C12.8355 118.043 13.0986 118.153 13.1643 118.285H14.414V118.438H13.1643C13.0547 118.745 12.112 118.942 10.6212 118.942C11.542 119.184 12.5285 119.49 13.4932 119.797H12.3751C11.4762 119.534 10.6212 119.271 9.54688 118.964V118.789H10.1827C11.4323 118.789 12.112 118.635 12.1778 118.438H9.54688V118.285H12.1558C11.9804 118.109 11.3666 118.022 10.3581 118.022H9.54688V117.824H14.414V117.978Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_26",
    d: "M19.875 115.5C17.7922 114.973 14.9421 114.645 11.7851 114.645C8.64992 114.645 5.7998 114.973 3.71702 115.5H0.296875V117.604C0.296875 119.249 5.42709 120.586 11.7851 120.586C18.143 120.586 23.2952 119.249 23.2952 117.604V115.5H19.875Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_27",
    d: "M23.2952 115.499C23.2952 117.144 18.143 118.459 11.7851 118.459C5.42709 118.459 0.296875 117.144 0.296875 115.499C0.296875 113.855 5.42709 112.518 11.7851 112.518C18.143 112.518 23.2952 113.855 23.2952 115.499Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_28",
    d: "M21.2344 115.502C21.2344 116.839 17.0031 117.935 11.7852 117.935C6.56727 117.935 2.33594 116.839 2.33594 115.502C2.33594 114.143 6.56727 113.068 11.7852 113.068C17.0031 113.068 21.2344 114.143 21.2344 115.502Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_29",
    d: "M19.9866 115.5C19.9866 116.662 16.3253 117.604 11.787 117.604C7.27068 117.604 3.60938 116.662 3.60938 115.5C3.60938 114.338 7.27068 113.373 11.787 113.373C16.3253 113.373 19.9866 114.338 19.9866 115.5Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_4",
    d: "M14.414 114.8H12.5066C12.8355 114.887 13.0986 114.975 13.1643 115.106H14.414V115.26H13.1643C13.0547 115.567 12.112 115.764 10.6212 115.786C11.542 116.027 12.5285 116.334 13.4932 116.641H12.3751C11.4762 116.356 10.6212 116.093 9.54688 115.786V115.611H10.1827C11.4323 115.611 12.112 115.479 12.1778 115.26H9.54688V115.106H12.1558C11.9804 114.931 11.3666 114.843 10.3581 114.843H9.54688V114.668H14.414V114.8Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_30",
    d: "M19.875 112.324C17.7922 111.798 14.9421 111.469 11.7851 111.469C8.64992 111.469 5.7998 111.798 3.71702 112.324H0.296875V114.45C0.296875 116.073 5.42709 117.41 11.7851 117.41C18.143 117.41 23.2952 116.073 23.2952 114.45V112.324H19.875Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_31",
    d: "M23.2952 112.325C23.2952 113.969 18.143 115.307 11.7851 115.307C5.42709 115.307 0.296875 113.969 0.296875 112.325C0.296875 110.681 5.42709 109.365 11.7851 109.365C18.143 109.365 23.2952 110.681 23.2952 112.325Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_32",
    d: "M21.2344 112.326C21.2344 113.685 17.0031 114.76 11.7852 114.76C6.56727 114.76 2.33594 113.685 2.33594 112.326C2.33594 110.989 6.56727 109.893 11.7852 109.893C17.0031 109.893 21.2344 110.989 21.2344 112.326Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_33",
    d: "M19.9866 112.325C19.9866 113.487 16.3253 114.452 11.787 114.452C7.27068 114.452 3.60938 113.487 3.60938 112.325C3.60938 111.163 7.27068 110.221 11.787 110.221C16.3253 110.221 19.9866 111.163 19.9866 112.325Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_5",
    d: "M14.414 111.646H12.5066C12.8355 111.711 13.0986 111.799 13.1643 111.953H14.414V112.084H13.1643C13.0547 112.391 12.112 112.588 10.6212 112.61C11.542 112.851 12.5285 113.158 13.4932 113.465H12.3751C11.4762 113.18 10.6212 112.917 9.54688 112.632V112.435H10.1827C11.4323 112.435 12.112 112.303 12.1778 112.084H9.54688V111.953H12.1558C11.9804 111.777 11.3666 111.69 10.3581 111.69H9.54688V111.492H14.414V111.646Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_34",
    d: "M19.875 109.144C17.7922 108.618 14.9421 108.289 11.7851 108.289C8.64992 108.289 5.7998 108.618 3.71702 109.144H0.296875V111.271C0.296875 112.915 5.42709 114.23 11.7851 114.23C18.143 114.23 23.2952 112.915 23.2952 111.271V109.144H19.875Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_35",
    d: "M23.2952 109.145C23.2952 110.79 18.143 112.127 11.7851 112.127C5.42709 112.127 0.296875 110.79 0.296875 109.145C0.296875 107.523 5.42709 106.186 11.7851 106.186C18.143 106.186 23.2952 107.523 23.2952 109.145Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_36",
    d: "M21.2344 109.144C21.2344 110.504 17.0031 111.6 11.7852 111.6C6.56727 111.6 2.33594 110.504 2.33594 109.144C2.33594 107.807 6.56727 106.711 11.7852 106.711C17.0031 106.711 21.2344 107.807 21.2344 109.144Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_37",
    d: "M19.9866 109.146C19.9866 110.33 16.3253 111.272 11.787 111.272C7.27068 111.272 3.60938 110.33 3.60938 109.146C3.60938 107.984 7.27068 107.041 11.787 107.041C16.3253 107.041 19.9866 107.984 19.9866 109.146Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_6",
    d: "M14.414 108.464H12.5066C12.8355 108.53 13.0986 108.639 13.1643 108.771H14.414V108.924H13.1643C13.0547 109.231 12.112 109.429 10.6212 109.429C11.542 109.67 12.5285 109.977 13.4932 110.284H12.3751C11.4762 109.999 10.6212 109.736 9.54688 109.451V109.253H10.1827C11.4323 109.253 12.112 109.122 12.1778 108.924H9.54688V108.771H12.1558C11.9804 108.596 11.3666 108.508 10.3581 108.508H9.54688V108.311H14.414V108.464Z",
    fill: "#A18044"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_38",
    d: "M93.4991 136.654H16.3047V95.6562H93.4991V136.654Z",
    fill: "#54735A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_39",
    d: "M124.977 125.824L93.4062 136.655V95.6566L124.977 84.8262V125.824Z",
    fill: "#445D49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_40",
    d: "M47.8972 84.8262H124.982L93.4114 95.6566H16.3047L47.8972 84.8262Z",
    fill: "#75A27D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_41",
    d: "M58.5101 88.5312H85.7178L78.3952 91.0744H51.1875L58.5101 88.5312Z",
    fill: "#445D49"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_7",
    d: "M66.183 105.894H60.132C61.1843 106.749 61.9516 107.955 62.1709 109.643H66.183V111.463H62.2147C61.842 115.212 58.8823 117.601 54.1906 117.755C57.0407 120.715 60.1539 124.464 63.2452 128.234H59.7154C56.8653 124.792 54.1906 121.592 50.7266 117.93V115.65H52.7436C56.7118 115.65 58.8384 114.006 59.1015 111.463H50.7266V109.643H58.9919C58.4657 107.516 56.5364 106.442 53.3355 106.442H50.7266V104.074H66.183V105.894Z",
    fill: "#2A372C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_42",
    d: "M127.68 126.591C125.597 126.065 122.747 125.736 119.59 125.736C116.455 125.736 113.604 126.065 111.522 126.591H108.102V128.718C108.102 130.362 113.254 131.678 119.59 131.678C125.948 131.678 131.1 130.362 131.1 128.718V126.591H127.68Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_43",
    d: "M131.1 126.593C131.1 128.237 125.948 129.574 119.59 129.574C113.254 129.574 108.102 128.237 108.102 126.593C108.102 124.97 113.254 123.633 119.59 123.633C125.948 123.633 131.1 124.97 131.1 126.593Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_44",
    d: "M129.039 126.592C129.039 127.951 124.808 129.047 119.59 129.047C114.372 129.047 110.141 127.951 110.141 126.592C110.141 125.254 114.372 124.158 119.59 124.158C124.808 124.158 129.039 125.254 129.039 126.592Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_45",
    d: "M127.791 126.591C127.791 127.775 124.13 128.718 119.592 128.718C115.075 128.718 111.414 127.775 111.414 126.591C111.414 125.429 115.075 124.486 119.592 124.486C124.13 124.486 127.791 125.429 127.791 126.591Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_8",
    d: "M122.248 125.913H120.319C120.648 125.979 120.911 126.089 120.977 126.22H122.248V126.374H120.977C120.867 126.681 119.924 126.878 118.434 126.878C119.354 127.119 120.341 127.426 121.306 127.733H120.188C119.289 127.448 118.434 127.207 117.359 126.9V126.703H117.995C119.245 126.703 119.924 126.571 119.99 126.374H117.359V126.22H119.968C119.793 126.045 119.179 125.957 118.171 125.957H117.359V125.76H122.248V125.913Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_46",
    d: "M127.68 123.435C125.597 122.909 122.747 122.58 119.59 122.58C116.455 122.58 113.604 122.909 111.522 123.435H108.102V125.54C108.102 127.184 113.254 128.521 119.59 128.521C125.948 128.521 131.1 127.184 131.1 125.54V123.435H127.68Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_47",
    d: "M131.1 123.435C131.1 125.079 125.948 126.395 119.59 126.395C113.254 126.395 108.102 125.079 108.102 123.435C108.102 121.79 113.254 120.453 119.59 120.453C125.948 120.453 131.1 121.79 131.1 123.435Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_48",
    d: "M129.039 123.434C129.039 124.771 124.808 125.868 119.59 125.868C114.372 125.868 110.141 124.771 110.141 123.434C110.141 122.075 114.372 120.979 119.59 120.979C124.808 120.979 129.039 122.075 129.039 123.434Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_49",
    d: "M127.791 123.435C127.791 124.597 124.13 125.54 119.592 125.54C115.075 125.54 111.414 124.597 111.414 123.435C111.414 122.251 115.075 121.309 119.592 121.309C124.13 121.309 127.791 122.251 127.791 123.435Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_9",
    d: "M122.248 122.732H120.319C120.648 122.797 120.911 122.907 120.977 123.039H122.248V123.192H120.977C120.867 123.499 119.924 123.696 118.434 123.696C119.354 123.959 120.341 124.244 121.306 124.573H120.188C119.289 124.288 118.434 124.025 117.359 123.718V123.543H117.995C119.245 123.543 119.924 123.389 119.99 123.192H117.359V123.039H119.968C119.793 122.863 119.179 122.775 118.171 122.775H117.359V122.578H122.248V122.732Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_50",
    d: "M127.68 120.259C125.597 119.733 122.747 119.404 119.59 119.404C116.455 119.404 113.604 119.733 111.522 120.259H108.102V122.364C108.102 124.008 113.254 125.346 119.59 125.346C125.948 125.346 131.1 124.008 131.1 122.364V120.259H127.68Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_51",
    d: "M131.1 120.259C131.1 121.903 125.948 123.219 119.59 123.219C113.254 123.219 108.102 121.903 108.102 120.259C108.102 118.615 113.254 117.277 119.59 117.277C125.948 117.277 131.1 118.615 131.1 120.259Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_52",
    d: "M129.039 120.262C129.039 121.599 124.808 122.695 119.59 122.695C114.372 122.695 110.141 121.599 110.141 120.262C110.141 118.902 114.372 117.828 119.59 117.828C124.808 117.828 129.039 118.902 129.039 120.262Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_53",
    d: "M127.791 120.259C127.791 121.421 124.13 122.364 119.592 122.364C115.075 122.364 111.414 121.421 111.414 120.259C111.414 119.097 115.075 118.133 119.592 118.133C124.13 118.133 127.791 119.097 127.791 120.259Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_10",
    d: "M122.248 119.581H120.319C120.648 119.647 120.911 119.735 120.977 119.866H122.248V120.02H120.977C120.867 120.327 119.924 120.524 118.434 120.546C119.354 120.787 120.341 121.094 121.306 121.401H120.188C119.289 121.116 118.434 120.853 117.359 120.546V120.37H117.995C119.245 120.37 119.924 120.239 119.99 120.02H117.359V119.866H119.968C119.793 119.713 119.179 119.625 118.171 119.625H117.359V119.428H122.248V119.581Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_54",
    d: "M127.68 117.08C125.597 116.553 122.747 116.225 119.59 116.225C116.455 116.225 113.604 116.553 111.522 117.08H108.102V119.206C108.102 120.851 113.254 122.166 119.59 122.166C125.948 122.166 131.1 120.851 131.1 119.206V117.08H127.68Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_55",
    d: "M131.1 117.081C131.1 118.725 125.948 120.062 119.59 120.062C113.254 120.062 108.102 118.725 108.102 117.081C108.102 115.437 113.254 114.121 119.59 114.121C125.948 114.121 131.1 115.437 131.1 117.081Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_56",
    d: "M129.039 117.08C129.039 118.439 124.808 119.536 119.59 119.536C114.372 119.536 110.141 118.439 110.141 117.08C110.141 115.743 114.372 114.646 119.59 114.646C124.808 114.646 129.039 115.743 129.039 117.08Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_57",
    d: "M127.791 117.081C127.791 118.265 124.13 119.208 119.592 119.208C115.075 119.208 111.414 118.265 111.414 117.081C111.414 115.919 115.075 114.977 119.592 114.977C124.13 114.977 127.791 115.919 127.791 117.081Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_11",
    d: "M122.248 116.403H120.319C120.648 116.469 120.911 116.557 120.977 116.71H122.248V116.864H120.977C120.867 117.171 119.924 117.346 118.434 117.368C119.354 117.609 120.341 117.916 121.306 118.223H120.188C119.289 117.938 118.434 117.675 117.359 117.39V117.193H117.995C119.245 117.193 119.924 117.061 119.99 116.864H117.359V116.71H119.968C119.793 116.535 119.179 116.447 118.171 116.447H117.359V116.25H122.248V116.403Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_58",
    d: "M127.68 113.902C125.597 113.376 122.747 113.047 119.59 113.047C116.455 113.047 113.604 113.376 111.522 113.902H108.102V116.029C108.102 117.673 113.254 118.988 119.59 118.988C125.948 118.988 131.1 117.673 131.1 116.029V113.902H127.68Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_59",
    d: "M131.1 113.903C131.1 115.547 125.948 116.885 119.59 116.885C113.254 116.885 108.102 115.547 108.102 113.903C108.102 112.281 113.254 110.943 119.59 110.943C125.948 110.943 131.1 112.281 131.1 113.903Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_60",
    d: "M129.039 113.902C129.039 115.262 124.808 116.358 119.59 116.358C114.372 116.358 110.141 115.262 110.141 113.902C110.141 112.565 114.372 111.469 119.59 111.469C124.808 111.469 129.039 112.565 129.039 113.902Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_61",
    d: "M127.791 113.904C127.791 115.087 124.13 116.03 119.592 116.03C115.075 116.03 111.414 115.087 111.414 113.904C111.414 112.742 115.075 111.799 119.592 111.799C124.13 111.799 127.791 112.742 127.791 113.904Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_12",
    d: "M122.248 113.224H120.319C120.648 113.29 120.911 113.399 120.977 113.531H122.248V113.684H120.977C120.867 113.991 119.924 114.188 118.434 114.188C119.354 114.43 120.341 114.737 121.306 115.043H120.188C119.289 114.758 118.434 114.517 117.359 114.21V114.013H117.995C119.245 114.013 119.924 113.881 119.99 113.684H117.359V113.531H119.968C119.793 113.355 119.179 113.268 118.171 113.268H117.359V113.07H122.248V113.224Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_62",
    d: "M127.68 110.746C125.597 110.219 122.747 109.891 119.59 109.891C116.455 109.891 113.604 110.219 111.522 110.746H108.102V112.85C108.102 114.495 113.254 115.832 119.59 115.832C125.948 115.832 131.1 114.495 131.1 112.85V110.746H127.68Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_63",
    d: "M131.1 110.745C131.1 112.39 125.948 113.705 119.59 113.705C113.254 113.705 108.102 112.39 108.102 110.745C108.102 109.101 113.254 107.764 119.59 107.764C125.948 107.764 131.1 109.101 131.1 110.745Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_64",
    d: "M129.039 110.745C129.039 112.082 124.808 113.178 119.59 113.178C114.372 113.178 110.141 112.082 110.141 110.745C110.141 109.385 114.372 108.289 119.59 108.289C124.808 108.289 129.039 109.385 129.039 110.745Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_65",
    d: "M127.791 110.746C127.791 111.908 124.13 112.85 119.592 112.85C115.075 112.85 111.414 111.908 111.414 110.746C111.414 109.562 115.075 108.619 119.592 108.619C124.13 108.619 127.791 109.562 127.791 110.746Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_13",
    d: "M122.248 110.046H120.319C120.648 110.112 120.911 110.221 120.977 110.353H122.248V110.506H120.977C120.867 110.813 119.924 111.011 118.434 111.011C119.354 111.274 120.341 111.559 121.306 111.888H120.188C119.289 111.603 118.434 111.34 117.359 111.033V110.857H117.995C119.245 110.857 119.924 110.726 119.99 110.506H117.359V110.353H119.968C119.793 110.178 119.179 110.09 118.171 110.09H117.359V109.893H122.248V110.046Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_66",
    d: "M127.68 107.564C125.597 107.038 122.747 106.709 119.59 106.709C116.455 106.709 113.604 107.038 111.522 107.564H108.102V109.669C108.102 111.313 113.254 112.65 119.59 112.65C125.948 112.65 131.1 111.313 131.1 109.669V107.564H127.68Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_67",
    d: "M131.1 107.564C131.1 109.208 125.948 110.523 119.59 110.523C113.254 110.523 108.102 109.208 108.102 107.564C108.102 105.919 113.254 104.582 119.59 104.582C125.948 104.582 131.1 105.919 131.1 107.564Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_68",
    d: "M129.039 107.566C129.039 108.904 124.808 110 119.59 110C114.372 110 110.141 108.904 110.141 107.566C110.141 106.229 114.372 105.133 119.59 105.133C124.808 105.133 129.039 106.229 129.039 107.566Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_69",
    d: "M127.791 107.564C127.791 108.726 124.13 109.669 119.592 109.669C115.075 109.669 111.414 108.726 111.414 107.564C111.414 106.402 115.075 105.438 119.592 105.438C124.13 105.438 127.791 106.402 127.791 107.564Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_14",
    d: "M122.248 106.888H120.319C120.648 106.954 120.911 107.041 120.977 107.173H122.248V107.326H120.977C120.867 107.633 119.924 107.831 118.434 107.853C119.354 108.094 120.341 108.401 121.306 108.708H120.188C119.289 108.423 118.434 108.159 117.359 107.853V107.677H117.995C119.245 107.677 119.924 107.546 119.99 107.326H117.359V107.173H119.968C119.793 107.019 119.179 106.932 118.171 106.932H117.359V106.734H122.248V106.888Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_70",
    d: "M127.68 104.382C125.597 103.856 122.747 103.527 119.59 103.527C116.455 103.527 113.604 103.856 111.522 104.382H108.102V106.509C108.102 108.153 113.254 109.469 119.59 109.469C125.948 109.469 131.1 108.153 131.1 106.509V104.382H127.68Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_71",
    d: "M131.1 104.384C131.1 106.028 125.948 107.365 119.59 107.365C113.254 107.365 108.102 106.028 108.102 104.384C108.102 102.739 113.254 101.424 119.59 101.424C125.948 101.424 131.1 102.739 131.1 104.384Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_72",
    d: "M129.039 104.383C129.039 105.742 124.808 106.838 119.59 106.838C114.372 106.838 110.141 105.742 110.141 104.383C110.141 103.045 114.372 101.949 119.59 101.949C124.808 101.949 129.039 103.045 129.039 104.383Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_73",
    d: "M127.791 104.384C127.791 105.568 124.13 106.511 119.592 106.511C115.075 106.511 111.414 105.568 111.414 104.384C111.414 103.222 115.075 102.279 119.592 102.279C124.13 102.279 127.791 103.222 127.791 104.384Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_15",
    d: "M122.248 103.702H120.319C120.648 103.768 120.911 103.856 120.977 104.009H122.248V104.163H120.977C120.867 104.47 119.924 104.645 118.434 104.667C119.354 104.908 120.341 105.215 121.306 105.522H120.188C119.289 105.237 118.434 104.974 117.359 104.689V104.492H117.995C119.245 104.492 119.924 104.36 119.99 104.163H117.359V104.009H119.968C119.793 103.834 119.179 103.746 118.171 103.746H117.359V103.549H122.248V103.702Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_74",
    d: "M127.68 101.203C125.597 100.677 122.747 100.348 119.59 100.348C116.455 100.348 113.604 100.677 111.522 101.203H108.102V103.329C108.102 104.974 113.254 106.289 119.59 106.289C125.948 106.289 131.1 104.974 131.1 103.329V101.203H127.68Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_75",
    d: "M131.1 101.204C131.1 102.848 125.948 104.186 119.59 104.186C113.254 104.186 108.102 102.848 108.102 101.204C108.102 99.5815 113.254 98.2441 119.59 98.2441C125.948 98.2441 131.1 99.5815 131.1 101.204Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_76",
    d: "M129.039 101.203C129.039 102.562 124.808 103.659 119.59 103.659C114.372 103.659 110.141 102.562 110.141 101.203C110.141 99.8657 114.372 98.7695 119.59 98.7695C124.808 98.7695 129.039 99.8657 129.039 101.203Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_77",
    d: "M127.791 101.204C127.791 102.388 124.13 103.331 119.592 103.331C115.075 103.331 111.414 102.388 111.414 101.204C111.414 100.042 115.075 99.0996 119.592 99.0996C124.13 99.0996 127.791 100.042 127.791 101.204Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_16",
    d: "M122.248 100.523H120.319C120.648 100.588 120.911 100.698 120.977 100.83H122.248V100.983H120.977C120.867 101.29 119.924 101.487 118.434 101.487C119.354 101.728 120.341 102.035 121.306 102.342H120.188C119.289 102.057 118.434 101.816 117.359 101.509V101.312H117.995C119.245 101.312 119.924 101.18 119.99 100.983H117.359V100.83H119.968C119.793 100.654 119.179 100.566 118.171 100.566H117.359V100.369H122.248V100.523Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_78",
    d: "M127.68 98.0523C125.597 97.5261 122.747 97.1973 119.59 97.1973C116.455 97.1973 113.604 97.5261 111.522 98.0523H108.102V100.157C108.102 101.801 113.254 103.139 119.59 103.139C125.948 103.139 131.1 101.801 131.1 100.157V98.0523H127.68Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_79",
    d: "M131.1 98.052C131.1 99.6963 125.948 101.012 119.59 101.012C113.254 101.012 108.102 99.6963 108.102 98.052C108.102 96.4077 113.254 95.0703 119.59 95.0703C125.948 95.0703 131.1 96.4077 131.1 98.052Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_80",
    d: "M129.039 98.0512C129.039 99.3886 124.808 100.485 119.59 100.485C114.372 100.485 110.141 99.3886 110.141 98.0512C110.141 96.6919 114.372 95.5957 119.59 95.5957C124.808 95.5957 129.039 96.6919 129.039 98.0512Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_81",
    d: "M127.791 98.0524C127.791 99.2144 124.13 100.157 119.592 100.157C115.075 100.157 111.414 99.2144 111.414 98.0524C111.414 96.8685 115.075 95.9258 119.592 95.9258C124.13 95.9258 127.791 96.8685 127.791 98.0524Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_17",
    d: "M122.248 97.3527H120.319C120.648 97.4185 120.911 97.5281 120.977 97.6596H122.248V97.8131H120.977C120.867 98.12 119.924 98.3174 118.434 98.3174C119.354 98.5804 120.341 98.8655 121.306 99.1943H120.188C119.289 98.9093 118.434 98.6462 117.359 98.3393V98.1639H117.995C119.245 98.1639 119.924 98.0323 119.99 97.8131H117.359V97.6596H119.968C119.793 97.4842 119.179 97.3965 118.171 97.3965H117.359V97.1992H122.248V97.3527Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_82",
    d: "M127.68 94.8726C125.597 94.3464 122.747 94.0176 119.59 94.0176C116.455 94.0176 113.604 94.3464 111.522 94.8726H108.102V96.9773C108.102 98.6216 113.254 99.959 119.59 99.959C125.948 99.959 131.1 98.6216 131.1 96.9773V94.8726H127.68Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_83",
    d: "M131.1 94.8723C131.1 96.5166 125.948 97.832 119.59 97.832C113.254 97.832 108.102 96.5166 108.102 94.8723C108.102 93.228 113.254 91.8906 119.59 91.8906C125.948 91.8906 131.1 93.228 131.1 94.8723Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_84",
    d: "M129.039 94.875C129.039 96.2123 124.808 97.3085 119.59 97.3085C114.372 97.3085 110.141 96.2123 110.141 94.875C110.141 93.5376 114.372 92.4414 119.59 92.4414C124.808 92.4414 129.039 93.5376 129.039 94.875Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_85",
    d: "M127.791 94.8727C127.791 96.0347 124.13 96.9774 119.592 96.9774C115.075 96.9774 111.414 96.0347 111.414 94.8727C111.414 93.7108 115.075 92.7461 119.592 92.7461C124.13 92.7461 127.791 93.7108 127.791 94.8727Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_18",
    d: "M122.248 94.1906H120.319C120.648 94.2563 120.911 94.344 120.977 94.4756H122.248V94.629H120.977C120.867 94.936 119.924 95.1333 118.434 95.1552C119.354 95.3964 120.341 95.7033 121.306 96.0103H120.188C119.289 95.7253 118.434 95.4622 117.359 95.1552V94.9798H117.995C119.245 94.9798 119.924 94.8483 119.99 94.629H117.359V94.4756H119.968C119.793 94.3221 119.179 94.2344 118.171 94.2344H117.359V94.0371H122.248V94.1906Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_86",
    d: "M127.68 91.689C125.597 91.1628 122.747 90.834 119.59 90.834C116.455 90.834 113.604 91.1628 111.522 91.689H108.102V93.8157C108.102 95.46 113.254 96.7754 119.59 96.7754C125.948 96.7754 131.1 95.46 131.1 93.8157V91.689H127.68Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_87",
    d: "M131.1 91.6902C131.1 93.3345 125.948 94.6719 119.59 94.6719C113.254 94.6719 108.102 93.3345 108.102 91.6902C108.102 90.0459 113.254 88.7305 119.59 88.7305C125.948 88.7305 131.1 90.0459 131.1 91.6902Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_88",
    d: "M129.039 91.6894C129.039 93.0487 124.808 94.1449 119.59 94.1449C114.372 94.1449 110.141 93.0487 110.141 91.6894C110.141 90.3521 114.372 89.2559 119.59 89.2559C124.808 89.2559 129.039 90.3521 129.039 91.6894Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_89",
    d: "M127.791 91.6906C127.791 92.8745 124.13 93.8173 119.592 93.8173C115.075 93.8173 111.414 92.8745 111.414 91.6906C111.414 90.5287 115.075 89.5859 119.592 89.5859C124.13 89.5859 127.791 90.5287 127.791 91.6906Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_19",
    d: "M122.248 91.0109H120.319C120.648 91.0767 120.911 91.1644 120.977 91.3178H122.248V91.4713H120.977C120.867 91.7782 119.924 91.9536 118.434 91.9755C119.354 92.2167 120.341 92.5236 121.306 92.8306H120.188C119.289 92.5456 118.434 92.2825 117.359 91.9975V91.8002H117.995C119.245 91.8002 119.924 91.6686 119.99 91.4713H117.359V91.3178H119.968C119.793 91.1424 119.179 91.0547 118.171 91.0547H117.359V90.8574H122.248V91.0109Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_90",
    d: "M127.68 88.5113C125.597 87.9851 122.747 87.6562 119.59 87.6562C116.455 87.6562 113.604 87.9851 111.522 88.5113H108.102V90.6379C108.102 92.2822 113.254 93.5977 119.59 93.5977C125.948 93.5977 131.1 92.2822 131.1 90.6379V88.5113H127.68Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_91",
    d: "M131.1 88.5125C131.1 90.1568 125.948 91.4941 119.59 91.4941C113.254 91.4941 108.102 90.1568 108.102 88.5125C108.102 86.8901 113.254 85.5527 119.59 85.5527C125.948 85.5527 131.1 86.8901 131.1 88.5125Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_92",
    d: "M129.039 88.5117C129.039 89.871 124.808 90.9672 119.59 90.9672C114.372 90.9672 110.141 89.871 110.141 88.5117C110.141 87.1743 114.372 86.0781 119.59 86.0781C124.808 86.0781 129.039 87.1743 129.039 88.5117Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_93",
    d: "M127.791 88.5129C127.791 89.6968 124.13 90.6395 119.592 90.6395C115.075 90.6395 111.414 89.6968 111.414 88.5129C111.414 87.3509 115.075 86.4082 119.592 86.4082C124.13 86.4082 127.791 87.3509 127.791 88.5129Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_20",
    d: "M122.248 87.8331H120.319C120.648 87.8989 120.911 88.0085 120.977 88.1401H122.248V88.2936H120.977C120.867 88.6005 119.924 88.7978 118.434 88.7978C119.354 89.039 120.341 89.3459 121.306 89.6528H120.188C119.289 89.3678 118.434 89.1267 117.359 88.8197V88.6224H117.995C119.245 88.6224 119.924 88.4909 119.99 88.2936H117.359V88.1401H119.968C119.793 87.9647 119.179 87.877 118.171 87.877H117.359V87.6797H122.248V87.8331Z",
    fill: "#A18044"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_94",
    d: "M144.563 131.375C142.48 130.826 139.63 130.52 136.494 130.52C133.337 130.52 130.487 130.826 128.405 131.375H124.984V133.479C124.984 135.124 130.137 136.461 136.494 136.461C142.852 136.461 148.005 135.124 148.005 133.479V131.375H144.563Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_95",
    d: "M148.005 131.374C148.005 132.997 142.852 134.334 136.494 134.334C130.137 134.334 124.984 132.997 124.984 131.374C124.984 129.73 130.137 128.393 136.494 128.393C142.852 128.393 148.005 129.73 148.005 131.374Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_96",
    d: "M145.945 131.373C145.945 132.711 141.714 133.807 136.496 133.807C131.278 133.807 127.047 132.711 127.047 131.373C127.047 130.014 131.278 128.918 136.496 128.918C141.714 128.918 145.945 130.014 145.945 131.373Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_97",
    d: "M144.696 131.375C144.696 132.537 141.013 133.479 136.496 133.479C131.958 133.479 128.297 132.537 128.297 131.375C128.297 130.191 131.958 129.248 136.496 129.248C141.013 129.248 144.696 130.191 144.696 131.375Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_21",
    d: "M139.123 130.673H137.216C137.545 130.739 137.786 130.848 137.852 130.98H139.123V131.133H137.874C137.742 131.44 136.821 131.638 135.331 131.638C136.229 131.879 137.216 132.186 138.203 132.493H137.084C136.164 132.23 135.331 131.967 134.234 131.66V131.484H134.87C136.12 131.484 136.799 131.331 136.887 131.133H134.234V130.98H136.843C136.69 130.805 136.076 130.717 135.067 130.717H134.234V130.52H139.123V130.673Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_98",
    d: "M144.563 128.195C142.48 127.669 139.63 127.34 136.494 127.34C133.337 127.34 130.487 127.669 128.405 128.195H124.984V130.3C124.984 131.944 130.137 133.281 136.494 133.281C142.852 133.281 148.005 131.944 148.005 130.3V128.195H144.563Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_99",
    d: "M148.005 128.195C148.005 129.839 142.852 131.154 136.494 131.154C130.137 131.154 124.984 129.839 124.984 128.195C124.984 126.55 130.137 125.213 136.494 125.213C142.852 125.213 148.005 126.55 148.005 128.195Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_100",
    d: "M145.945 128.197C145.945 129.535 141.714 130.631 136.496 130.631C131.278 130.631 127.047 129.535 127.047 128.197C127.047 126.838 131.278 125.764 136.496 125.764C141.714 125.764 145.945 126.838 145.945 128.197Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_101",
    d: "M144.696 128.195C144.696 129.357 141.013 130.3 136.496 130.3C131.958 130.3 128.297 129.357 128.297 128.195C128.297 127.033 131.958 126.068 136.496 126.068C141.013 126.068 144.696 127.033 144.696 128.195Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_22",
    d: "M139.123 127.493H137.216C137.545 127.581 137.786 127.668 137.852 127.8H139.123V127.953H137.874C137.742 128.26 136.821 128.458 135.331 128.479C136.229 128.721 137.216 129.028 138.203 129.334H137.084C136.164 129.049 135.331 128.786 134.234 128.479V128.304H134.87C136.12 128.304 136.799 128.173 136.887 127.953H134.234V127.8H136.843C136.69 127.624 136.076 127.537 135.067 127.537H134.234V127.361H139.123V127.493Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_102",
    d: "M144.563 125.015C142.48 124.489 139.63 124.16 136.494 124.16C133.337 124.16 130.487 124.489 128.405 125.015H124.984V127.142C124.984 128.764 130.137 130.102 136.494 130.102C142.852 130.102 148.005 128.764 148.005 127.142V125.015H144.563Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_103",
    d: "M148.005 125.016C148.005 126.661 142.852 127.998 136.494 127.998C130.137 127.998 124.984 126.661 124.984 125.016C124.984 123.372 130.137 122.057 136.494 122.057C142.852 122.057 148.005 123.372 148.005 125.016Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_104",
    d: "M145.945 125.016C145.945 126.375 141.714 127.449 136.496 127.449C131.278 127.449 127.047 126.375 127.047 125.016C127.047 123.678 131.278 122.582 136.496 122.582C141.714 122.582 145.945 123.678 145.945 125.016Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_105",
    d: "M144.696 125.017C144.696 126.179 141.013 127.143 136.496 127.143C131.958 127.143 128.297 126.179 128.297 125.017C128.297 123.855 131.958 122.912 136.496 122.912C141.013 122.912 144.696 123.855 144.696 125.017Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_23",
    d: "M139.123 124.337H137.216C137.545 124.403 137.786 124.491 137.852 124.644H139.123V124.776H137.874C137.742 125.082 136.821 125.28 135.331 125.302C136.229 125.543 137.216 125.85 138.203 126.157H137.084C136.164 125.872 135.331 125.609 134.234 125.302V125.126H134.87C136.12 125.126 136.799 124.995 136.887 124.776H134.234V124.644H136.843C136.69 124.469 136.076 124.381 135.067 124.381H134.234V124.184H139.123V124.337Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_106",
    d: "M144.563 121.837C142.48 121.311 139.63 120.982 136.494 120.982C133.337 120.982 130.487 121.311 128.405 121.837H124.984V123.964C124.984 125.608 130.137 126.924 136.494 126.924C142.852 126.924 148.005 125.608 148.005 123.964V121.837H144.563Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_107",
    d: "M148.005 121.839C148.005 123.483 142.852 124.82 136.494 124.82C130.137 124.82 124.984 123.483 124.984 121.839C124.984 120.194 130.137 118.879 136.494 118.879C142.852 118.879 148.005 120.194 148.005 121.839Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_108",
    d: "M145.945 121.838C145.945 123.197 141.714 124.293 136.496 124.293C131.278 124.293 127.047 123.197 127.047 121.838C127.047 120.501 131.278 119.404 136.496 119.404C141.714 119.404 145.945 120.501 145.945 121.838Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_109",
    d: "M144.696 121.839C144.696 123.023 141.013 123.966 136.496 123.966C131.958 123.966 128.297 123.023 128.297 121.839C128.297 120.677 131.958 119.734 136.496 119.734C141.013 119.734 144.696 120.677 144.696 121.839Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_24",
    d: "M139.123 121.159H137.216C137.545 121.225 137.786 121.335 137.852 121.466H139.123V121.62H137.874C137.742 121.927 136.821 122.124 135.331 122.124C136.229 122.365 137.216 122.672 138.203 122.979H137.084C136.164 122.694 135.331 122.431 134.234 122.146V121.949H134.87C136.12 121.949 136.799 121.817 136.887 121.62H134.234V121.466H136.843C136.69 121.291 136.076 121.203 135.067 121.203H134.234V121.006H139.123V121.159Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_110",
    d: "M144.563 118.679C142.48 118.131 139.63 117.824 136.494 117.824C133.337 117.824 130.487 118.131 128.405 118.679H124.984V120.784C124.984 122.428 130.137 123.766 136.494 123.766C142.852 123.766 148.005 122.428 148.005 120.784V118.679H144.563Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_111",
    d: "M148.005 118.679C148.005 120.301 142.852 121.639 136.494 121.639C130.137 121.639 124.984 120.301 124.984 118.679C124.984 117.035 130.137 115.697 136.494 115.697C142.852 115.697 148.005 117.035 148.005 118.679Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_112",
    d: "M145.945 118.678C145.945 120.016 141.714 121.112 136.496 121.112C131.278 121.112 127.047 120.016 127.047 118.678C127.047 117.319 131.278 116.223 136.496 116.223C141.714 116.223 145.945 117.319 145.945 118.678Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_113",
    d: "M144.696 118.679C144.696 119.841 141.013 120.784 136.496 120.784C131.958 120.784 128.297 119.841 128.297 118.679C128.297 117.495 131.958 116.553 136.496 116.553C141.013 116.553 144.696 117.495 144.696 118.679Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_25",
    d: "M139.123 117.978H137.216C137.545 118.043 137.786 118.153 137.852 118.285H139.123V118.438H137.874C137.742 118.745 136.821 118.942 135.331 118.942C136.229 119.184 137.216 119.49 138.203 119.797H137.084C136.164 119.534 135.331 119.271 134.234 118.964V118.789H134.87C136.12 118.789 136.799 118.635 136.887 118.438H134.234V118.285H136.843C136.69 118.109 136.076 118.022 135.067 118.022H134.234V117.824H139.123V117.978Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_114",
    d: "M144.563 115.498C142.48 114.971 139.63 114.643 136.494 114.643C133.337 114.643 130.487 114.971 128.405 115.498H124.984V117.602C124.984 119.247 130.137 120.584 136.494 120.584C142.852 120.584 148.005 119.247 148.005 117.602V115.498H144.563Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_115",
    d: "M148.005 115.497C148.005 117.142 142.852 118.457 136.494 118.457C130.137 118.457 124.984 117.142 124.984 115.497C124.984 113.853 130.137 112.516 136.494 112.516C142.852 112.516 148.005 113.853 148.005 115.497Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_116",
    d: "M145.945 115.5C145.945 116.837 141.714 117.934 136.496 117.934C131.278 117.934 127.047 116.837 127.047 115.5C127.047 114.141 131.278 113.066 136.496 113.066C141.714 113.066 145.945 114.141 145.945 115.5Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_117",
    d: "M144.696 115.498C144.696 116.66 141.013 117.602 136.496 117.602C131.958 117.602 128.297 116.66 128.297 115.498C128.297 114.336 131.958 113.371 136.496 113.371C141.013 113.371 144.696 114.336 144.696 115.498Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_26",
    d: "M139.123 114.798H137.216C137.545 114.885 137.786 114.973 137.852 115.104H139.123V115.258H137.874C137.742 115.565 136.821 115.762 135.331 115.784C136.229 116.025 137.216 116.332 138.203 116.639H137.084C136.164 116.354 135.331 116.091 134.234 115.784V115.609H134.87C136.12 115.609 136.799 115.477 136.887 115.258H134.234V115.104H136.843C136.69 114.929 136.076 114.841 135.067 114.841H134.234V114.666H139.123V114.798Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_118",
    d: "M144.563 112.32C142.48 111.794 139.63 111.465 136.494 111.465C133.337 111.465 130.487 111.794 128.405 112.32H124.984V114.447C124.984 116.069 130.137 117.406 136.494 117.406C142.852 117.406 148.005 116.069 148.005 114.447V112.32H144.563Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_119",
    d: "M148.005 112.321C148.005 113.965 142.852 115.303 136.494 115.303C130.137 115.303 124.984 113.965 124.984 112.321C124.984 110.677 130.137 109.361 136.494 109.361C142.852 109.361 148.005 110.677 148.005 112.321Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_120",
    d: "M145.945 112.32C145.945 113.68 141.714 114.754 136.496 114.754C131.278 114.754 127.047 113.68 127.047 112.32C127.047 110.983 131.278 109.887 136.496 109.887C141.714 109.887 145.945 110.983 145.945 112.32Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_121",
    d: "M144.696 112.321C144.696 113.483 141.013 114.448 136.496 114.448C131.958 114.448 128.297 113.483 128.297 112.321C128.297 111.16 131.958 110.217 136.496 110.217C141.013 110.217 144.696 111.16 144.696 112.321Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_27",
    d: "M139.123 111.64H137.216C137.545 111.706 137.786 111.793 137.852 111.947H139.123V112.078H137.874C137.742 112.385 136.821 112.583 135.331 112.604C136.229 112.846 137.216 113.153 138.203 113.459H137.084C136.164 113.174 135.331 112.911 134.234 112.626V112.429H134.87C136.12 112.429 136.799 112.298 136.887 112.078H134.234V111.947H136.843C136.69 111.771 136.076 111.684 135.067 111.684H134.234V111.486H139.123V111.64Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_122",
    d: "M144.563 109.142C142.48 108.616 139.63 108.287 136.494 108.287C133.337 108.287 130.487 108.616 128.405 109.142H124.984V111.269C124.984 112.913 130.137 114.229 136.494 114.229C142.852 114.229 148.005 112.913 148.005 111.269V109.142H144.563Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_123",
    d: "M148.005 109.143C148.005 110.788 142.852 112.125 136.494 112.125C130.137 112.125 124.984 110.788 124.984 109.143C124.984 107.521 130.137 106.184 136.494 106.184C142.852 106.184 148.005 107.521 148.005 109.143Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_124",
    d: "M145.945 109.143C145.945 110.502 141.714 111.598 136.496 111.598C131.278 111.598 127.047 110.502 127.047 109.143C127.047 107.805 131.278 106.709 136.496 106.709C141.714 106.709 145.945 107.805 145.945 109.143Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_125",
    d: "M144.696 109.144C144.696 110.328 141.013 111.27 136.496 111.27C131.958 111.27 128.297 110.328 128.297 109.144C128.297 107.982 131.958 107.039 136.496 107.039C141.013 107.039 144.696 107.982 144.696 109.144Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_28",
    d: "M139.123 108.464H137.216C137.545 108.53 137.786 108.639 137.852 108.771H139.123V108.924H137.874C137.742 109.231 136.821 109.429 135.331 109.429C136.229 109.67 137.216 109.977 138.203 110.284H137.084C136.164 109.999 135.331 109.736 134.234 109.451V109.253H134.87C136.12 109.253 136.799 109.122 136.887 108.924H134.234V108.771H136.843C136.69 108.596 136.076 108.508 135.067 108.508H134.234V108.311H139.123V108.464Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_126",
    d: "M144.563 105.986C142.48 105.438 139.63 105.131 136.494 105.131C133.337 105.131 130.487 105.438 128.405 105.986H124.984V108.091C124.984 109.735 130.137 111.072 136.494 111.072C142.852 111.072 148.005 109.735 148.005 108.091V105.986H144.563Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_127",
    d: "M148.005 105.986C148.005 107.608 142.852 108.945 136.494 108.945C130.137 108.945 124.984 107.608 124.984 105.986C124.984 104.341 130.137 103.004 136.494 103.004C142.852 103.004 148.005 104.341 148.005 105.986Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_128",
    d: "M145.945 105.985C145.945 107.322 141.714 108.418 136.496 108.418C131.278 108.418 127.047 107.322 127.047 105.985C127.047 104.625 131.278 103.529 136.496 103.529C141.714 103.529 145.945 104.625 145.945 105.985Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_129",
    d: "M144.696 105.986C144.696 107.148 141.013 108.091 136.496 108.091C131.958 108.091 128.297 107.148 128.297 105.986C128.297 104.802 131.958 103.859 136.496 103.859C141.013 103.859 144.696 104.802 144.696 105.986Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_29",
    d: "M139.123 105.284H137.216C137.545 105.35 137.786 105.46 137.852 105.591H139.123V105.745H137.874C137.742 106.052 136.821 106.249 135.331 106.249C136.229 106.49 137.216 106.797 138.203 107.104H137.084C136.164 106.841 135.331 106.578 134.234 106.271V106.096H134.87C136.12 106.096 136.799 105.942 136.887 105.745H134.234V105.591H136.843C136.69 105.416 136.076 105.328 135.067 105.328H134.234V105.131H139.123V105.284Z",
    fill: "#A18044"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_130",
    d: "M117.569 135.955C115.486 135.428 112.636 135.1 109.479 135.1C106.344 135.1 103.494 135.428 101.411 135.955H97.9688V138.081C97.9688 139.726 103.121 141.041 109.479 141.041C115.837 141.041 120.989 139.726 120.989 138.081V135.955H117.569Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_131",
    d: "M120.989 135.956C120.989 137.6 115.837 138.938 109.479 138.938C103.121 138.938 97.9688 137.6 97.9688 135.956C97.9688 134.312 103.121 132.996 109.479 132.996C115.837 132.996 120.989 134.312 120.989 135.956Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_132",
    d: "M118.93 135.955C118.93 137.314 114.698 138.389 109.481 138.389C104.263 138.389 100.031 137.314 100.031 135.955C100.031 134.618 104.263 133.521 109.481 133.521C114.698 133.521 118.93 134.618 118.93 135.955Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_133",
    d: "M117.68 135.956C117.68 137.14 114.019 138.083 109.481 138.083C104.964 138.083 101.281 137.14 101.281 135.956C101.281 134.794 104.964 133.852 109.481 133.852C114.019 133.852 117.68 134.794 117.68 135.956Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_30",
    d: "M112.108 135.277H110.2C110.529 135.342 110.77 135.43 110.858 135.583H112.108V135.737H110.858C110.749 136.022 109.806 136.219 108.315 136.241C109.214 136.482 110.2 136.789 111.187 137.096H110.069C109.17 136.811 108.315 136.548 107.219 136.263V136.066H107.855C109.126 136.066 109.784 135.934 109.872 135.737H107.219V135.583H109.828C109.674 135.408 109.06 135.32 108.052 135.32H107.219V135.123H112.108V135.277Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_134",
    d: "M117.569 132.775C115.486 132.249 112.636 131.92 109.479 131.92C106.344 131.92 103.494 132.249 101.411 132.775H97.9688V134.902C97.9688 136.546 103.121 137.861 109.479 137.861C115.837 137.861 120.989 136.546 120.989 134.902V132.775H117.569Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_135",
    d: "M120.989 132.776C120.989 134.42 115.837 135.758 109.479 135.758C103.121 135.758 97.9688 134.42 97.9688 132.776C97.9688 131.154 103.121 129.816 109.479 129.816C115.837 129.816 120.989 131.154 120.989 132.776Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_136",
    d: "M118.93 132.775C118.93 134.135 114.698 135.231 109.481 135.231C104.263 135.231 100.031 134.135 100.031 132.775C100.031 131.438 104.263 130.342 109.481 130.342C114.698 130.342 118.93 131.438 118.93 132.775Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_137",
    d: "M117.68 132.777C117.68 133.96 114.019 134.903 109.481 134.903C104.964 134.903 101.281 133.96 101.281 132.777C101.281 131.615 104.964 130.672 109.481 130.672C114.019 130.672 117.68 131.615 117.68 132.777Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_31",
    d: "M112.108 132.095H110.2C110.529 132.161 110.77 132.27 110.858 132.402H112.108V132.555H110.858C110.749 132.862 109.806 133.06 108.315 133.06C109.214 133.301 110.2 133.608 111.187 133.915H110.069C109.17 133.63 108.315 133.388 107.219 133.081V132.884H107.855C109.126 132.884 109.784 132.753 109.872 132.555H107.219V132.402H109.828C109.674 132.226 109.06 132.139 108.052 132.139H107.219V131.941H112.108V132.095Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_138",
    d: "M117.569 129.621C115.486 129.094 112.636 128.766 109.479 128.766C106.344 128.766 103.494 129.094 101.411 129.621H97.9688V131.725C97.9688 133.37 103.121 134.707 109.479 134.707C115.837 134.707 120.989 133.37 120.989 131.725V129.621H117.569Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_139",
    d: "M120.989 129.62C120.989 131.265 115.837 132.58 109.479 132.58C103.121 132.58 97.9688 131.265 97.9688 129.62C97.9688 127.976 103.121 126.639 109.479 126.639C115.837 126.639 120.989 127.976 120.989 129.62Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_140",
    d: "M118.93 129.62C118.93 130.957 114.698 132.053 109.481 132.053C104.263 132.053 100.031 130.957 100.031 129.62C100.031 128.26 104.263 127.164 109.481 127.164C114.698 127.164 118.93 128.26 118.93 129.62Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_141",
    d: "M117.68 129.621C117.68 130.783 114.019 131.725 109.481 131.725C104.964 131.725 101.281 130.783 101.281 129.621C101.281 128.437 104.964 127.494 109.481 127.494C114.019 127.494 117.68 128.437 117.68 129.621Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_32",
    d: "M112.108 128.919H110.2C110.529 128.985 110.77 129.094 110.858 129.226H112.108V129.379H110.858C110.749 129.686 109.806 129.884 108.315 129.884C109.214 130.147 110.2 130.432 111.187 130.761H110.069C109.17 130.476 108.315 130.213 107.219 129.906V129.73H107.855C109.126 129.73 109.784 129.577 109.872 129.379H107.219V129.226H109.828C109.674 129.051 109.06 128.963 108.052 128.963H107.219V128.766H112.108V128.919Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_142",
    d: "M117.569 126.441C115.486 125.915 112.636 125.586 109.479 125.586C106.344 125.586 103.494 125.915 101.411 126.441H97.9688V128.546C97.9688 130.19 103.121 131.527 109.479 131.527C115.837 131.527 120.989 130.19 120.989 128.546V126.441H117.569Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_143",
    d: "M120.989 126.441C120.989 128.085 115.837 129.4 109.479 129.4C103.121 129.4 97.9688 128.085 97.9688 126.441C97.9688 124.796 103.121 123.459 109.479 123.459C115.837 123.459 120.989 124.796 120.989 126.441Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_144",
    d: "M118.93 126.443C118.93 127.781 114.698 128.877 109.481 128.877C104.263 128.877 100.031 127.781 100.031 126.443C100.031 125.084 104.263 124.01 109.481 124.01C114.698 124.01 118.93 125.084 118.93 126.443Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_145",
    d: "M117.68 126.441C117.68 127.603 114.019 128.546 109.481 128.546C104.964 128.546 101.281 127.603 101.281 126.441C101.281 125.279 104.964 124.314 109.481 124.314C114.019 124.314 117.68 125.279 117.68 126.441Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_33",
    d: "M112.108 125.761H110.2C110.529 125.827 110.77 125.914 110.858 126.046H112.108V126.199H110.858C110.749 126.506 109.806 126.704 108.315 126.726C109.214 126.967 110.2 127.274 111.187 127.581H110.069C109.17 127.296 108.315 127.032 107.219 126.726V126.55H107.855C109.126 126.55 109.784 126.419 109.872 126.199H107.219V126.046H109.828C109.674 125.892 109.06 125.805 108.052 125.805H107.219V125.607H112.108V125.761Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_146",
    d: "M117.569 123.261C115.486 122.735 112.636 122.406 109.479 122.406C106.344 122.406 103.494 122.735 101.411 123.261H97.9688V125.388C97.9688 127.032 103.121 128.348 109.479 128.348C115.837 128.348 120.989 127.032 120.989 125.388V123.261H117.569Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_147",
    d: "M120.989 123.262C120.989 124.907 115.837 126.244 109.479 126.244C103.121 126.244 97.9688 124.907 97.9688 123.262C97.9688 121.618 103.121 120.303 109.479 120.303C115.837 120.303 120.989 121.618 120.989 123.262Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_148",
    d: "M118.93 123.262C118.93 124.621 114.698 125.717 109.481 125.717C104.263 125.717 100.031 124.621 100.031 123.262C100.031 121.924 104.263 120.828 109.481 120.828C114.698 120.828 118.93 121.924 118.93 123.262Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_149",
    d: "M117.68 123.263C117.68 124.447 114.019 125.39 109.481 125.39C104.964 125.39 101.281 124.447 101.281 123.263C101.281 122.101 104.964 121.158 109.481 121.158C114.019 121.158 117.68 122.101 117.68 123.263Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_34",
    d: "M112.108 122.583H110.2C110.529 122.649 110.77 122.737 110.858 122.89H112.108V123.044H110.858C110.749 123.35 109.806 123.526 108.315 123.548C109.214 123.789 110.2 124.096 111.187 124.403H110.069C109.17 124.118 108.315 123.855 107.219 123.57V123.372H107.855C109.126 123.372 109.784 123.241 109.872 123.044H107.219V122.89H109.828C109.674 122.715 109.06 122.627 108.052 122.627H107.219V122.43H112.108V122.583Z",
    fill: "#A18044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_150",
    d: "M117.569 120.082C115.486 119.555 112.636 119.227 109.479 119.227C106.344 119.227 103.494 119.555 101.411 120.082H97.9688V122.208C97.9688 123.853 103.121 125.168 109.479 125.168C115.837 125.168 120.989 123.853 120.989 122.208V120.082H117.569Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_151",
    d: "M120.989 120.083C120.989 121.727 115.837 123.064 109.479 123.064C103.121 123.064 97.9688 121.727 97.9688 120.083C97.9688 118.46 103.121 117.123 109.479 117.123C115.837 117.123 120.989 118.46 120.989 120.083Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_152",
    d: "M118.93 120.082C118.93 121.441 114.698 122.538 109.481 122.538C104.263 122.538 100.031 121.441 100.031 120.082C100.031 118.745 104.263 117.648 109.481 117.648C114.698 117.648 118.93 118.745 118.93 120.082Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_153",
    d: "M117.68 120.083C117.68 121.267 114.019 122.21 109.481 122.21C104.964 122.21 101.281 121.267 101.281 120.083C101.281 118.921 104.964 117.979 109.481 117.979C114.019 117.979 117.68 118.921 117.68 120.083Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_35",
    d: "M112.108 119.403H110.2C110.529 119.469 110.77 119.579 110.858 119.71H112.108V119.864H110.858C110.749 120.171 109.806 120.368 108.315 120.368C109.214 120.609 110.2 120.916 111.187 121.223H110.069C109.17 120.938 108.315 120.697 107.219 120.39V120.193H107.855C109.126 120.193 109.784 120.061 109.872 119.864H107.219V119.71H109.828C109.674 119.535 109.06 119.447 108.052 119.447H107.219V119.25H112.108V119.403Z",
    fill: "#A18044"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_79",
    filter: "url(#filter0_d_842_238907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_154",
    d: "M61.7722 62.3804C60.4129 68.1025 54.6688 71.6542 48.9466 70.2949C43.2245 68.9356 39.6728 63.1915 41.0321 57.4474C42.3914 51.7253 48.1355 48.1955 53.8795 49.5548C59.6017 50.9141 63.1315 56.6582 61.7722 62.3804Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_155",
    d: "M59.9312 61.9405C58.8131 66.6542 54.0994 69.5482 49.3858 68.43C44.6721 67.3119 41.7781 62.5982 42.8963 57.8846C44.0144 53.1928 48.728 50.277 53.4417 51.3951C58.1334 52.5132 61.0493 57.2488 59.9312 61.9405Z",
    fill: "#EFC072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_156",
    d: "M58.7871 61.68C57.8225 65.7578 53.7227 68.2791 49.6448 67.3145C45.5669 66.3279 43.0457 62.25 44.0103 58.1721C44.9969 54.0943 49.0748 51.573 53.1526 52.5377C57.2305 53.5023 59.7518 57.6021 58.7871 61.68Z",
    fill: "#F6DD74"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>_36",
    d: "M54.3585 58.0824L52.6265 57.6659C52.8677 57.9728 52.9992 58.3674 52.9554 58.8717L54.0955 59.1348L53.9639 59.661L52.8458 59.3979C52.495 60.4502 51.4865 60.9106 50.1272 60.6475C50.7411 61.678 51.3769 62.9715 51.9907 64.2431L51.0042 64.0019C50.4122 62.8399 49.8641 61.7437 49.1406 60.4721L49.2941 59.8144L49.8641 59.946C50.9822 60.2091 51.7057 59.9021 51.9469 59.1786L49.5791 58.6305L49.6887 58.1044L52.0565 58.6525C52.0346 58.0167 51.5523 57.5782 50.6534 57.3589L49.908 57.1835L50.0614 56.5039L54.4682 57.5563L54.3585 58.0824Z",
    fill: "#A18044"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_842_238907",
    x: 36.7422,
    y: 45.2637,
    width: 29.3203,
    height: 29.3213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_842_238907"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_842_238907",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.386a14c963481106eb97a2f1d99680ae.svg";
export { ForwardRef as ReactComponent };